/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, inject, Input, OnInit } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterLink } from '@angular/router';
import { BankAccount } from '@src/app/model/bankAccount';
import { ServiceRequest } from '@src/app/model/serviceRequest';
import { BankAccountPageNavRoute } from '@src/app/routes/app-router';
import { ChosenWidget, IWidget } from '@src/app/shared/dashboard/DashboardTypes';
import { DateHelper } from '@src/app/shared/dateHelper';
import { MessageService } from '@src/app/shared/message.service';
import { NrHelper } from '@src/app/shared/NrHelper';
import { TenantService } from '@src/app/shared/tenant.service';

class BankSummary {
    accounts: BankAccount[];
    budget: number;
}

@Component({
    selector: 'app-bank-summary',
    imports: [RouterLink, MatCardModule, MatTooltipModule, MatIconModule],
    templateUrl: './bank-summary-widget.component.html',
    styleUrls: ['../../../../shared/dashboard/hello-world-widget/widget.component.scss']
})
export class BankSummaryWidgetComponent  implements IWidget, OnInit {
  title = $localize `Bank Account Summary`;
  host: ElementRef<Element> = inject(ElementRef);
  options: { name: string; action: () => void; }[];
  @Input() chosenWidget: ChosenWidget;
  dateHelper = DateHelper;
  nrHelper = NrHelper;

  http = inject(HttpClient);
  tenantSvc = inject(TenantService);
  msgSvc = inject(MessageService);

  routerLink = BankAccountPageNavRoute.getListRouterLink({srStatus: ServiceRequest.srOpen.id});

  accounts: BankAccount[] = [];
  defaultBank: BankAccount;
  unlinked = 0;
  failing = 0;

  daysCash: number;

  ngOnInit(): void {
    this.http.get<BankSummary>(this.tenantSvc.getPath('omc/dashboard/bankSummary')).subscribe( 
        data => this.getData(data),
        error => this.msgSvc.showError(error, 'Bank Summary')
    );
  }

  getData(data : BankSummary) {
    this.accounts = data.accounts;
    this.defaultBank = this.accounts.find(ba => ba.defaultAcct);
    const available = this.defaultBank.lastBalance || this.defaultBank.lastRecBalance;
    this.daysCash = Math.round(available / (data.budget / 365));
    this.unlinked = this.accounts.filter(ba => !ba.gocId).length;
  }

  navigate(bank: BankAccount) {
    return BankAccountPageNavRoute.getIdUrl(bank.id, bank.teamId)
  }
}
